var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtentiW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2536 26.9999V23.5259C21.2536 20.7929 19.0139 18.5778 16.2506 18.5778H6.23006C3.46677 18.5778 1.22705 20.7929 1.22705 23.5259V26.9999",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2506 9.62558C16.2506 12.3585 14.0109 14.5737 11.2476 14.5737C8.48435 14.5737 6.24463 12.3585 6.24463 9.62558C6.24463 6.89262 8.4698 4.67749 11.2476 4.67749C14.0255 4.67749 16.2506 6.89262 16.2506 9.62558Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7728 27V23.526C28.7728 21.2677 27.2311 19.2971 25.0205 18.7361",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0029 4.83569C22.679 5.51174 24.2933 8.21593 23.5952 10.8626C23.1444 12.603 21.7627 13.9695 20.0029 14.4154",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtentiW);
export default __webpack_public_path__ + "static/media/utentiW.ccfb2b7e68789115b43c3e2ad7da734e.svg";
export { ForwardRef as ReactComponent };